import { BaseEntity } from '../../../models';

export class RegiaoGeograficaIntermediaria implements BaseEntity {
    id: number;
    idEstado: number;
    codigoIbge: number;
    nome: string;

    constructor(props: Partial<RegiaoGeograficaIntermediaria>) {
        Object.assign(this, props);
    }
}
